module.exports = __webpack_public_path__ + "img/Differentiation-OVCA_10X_TIP.01b240e1.png";